import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ClientUserCarePlanSettings} from "../../models/client-user-care-plan-settings.model";
import {CommonUtils} from "../../utils/common";
import {VImage} from "../../models/vet-clinic.model";
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {ModalController} from "@ionic/angular";
import {FileService} from "../../providers/file.service";
import {AppStateService} from "../../providers/app-state.service";
import {VImageDropComponent} from "../v-image-drop/v-image-drop.component";
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {TranslateService} from "@ngx-translate/core";
import {ClientsService} from "../../providers/clients.service";

@Component({
  selector: 'app-client-user-care-plan-settings',
  templateUrl: './client-user-care-plan-settings.component.html',
  styleUrls: ['./client-user-care-plan-settings.component.scss'],
})
export class ClientUserCarePlanSettingsComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {


  @Input() clientUserCarePlanSettings: ClientUserCarePlanSettings;
  @Input() vClientUUID: string;
  @Output() clientUserCarePlanSettingsAddedEmitter: EventEmitter<ClientUserCarePlanSettings> = new EventEmitter<ClientUserCarePlanSettings>();
  @Output() clientUserCarePlanSettingsEditCanceledEmitter: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  hasUnsavedChanges: boolean = false;

  isBusy: boolean = false;
  isBusySub: Subscription;

  formGroup: FormGroup;

  vImages: VImage[];
  privatevImagesSub: Subscription;
  images: VImage[];


  photoUpload: File;
  largePhotoUpload: File;
  largePhotoImageUUID: string;
  photoImageUUID: string;

  private vImagesSub: Subscription;
  largePhoto: VImage;
  photo: VImage;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private vetClinicService: VetClinicService,
    private modalController: ModalController,
    private fileService: FileService,
    private appStateService: AppStateService,
    private translateService: TranslateService,
    private clientsService: ClientsService) {
    super(commonUtils, appStateService, modalController, translateService);

  }


  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nowe ustawienia';
      this.actionBtnLabel = 'Dodaj nowe ustawienia';
      this.actionQuestion = 'Na pewno chcesz dodać nowe ustawienia?';
      this.actionSuccess = 'Nowe ustawienia zostały zapisane';
      this.actionError = 'Wystąpił błąd podczas zapisywania ustawień'
      this.formGroup = this.formBuilder
        .group({
          photoImageUUID: [''],
          largePhotoImageUUID: [''],
          name: ['', Validators.required],
          description: ['', Validators.required]
        });
    } else {
      this.photo = this.clientUserCarePlanSettings.photo;
      this.photoImageUUID = this.clientUserCarePlanSettings.photoImageUUID;
      this.largePhotoImageUUID = this.clientUserCarePlanSettings.largePhotoImageUUID;
      this.largePhoto = this.clientUserCarePlanSettings.largePhoto;
      this.componentTitle = 'Zmień ustawienia';
      this.actionBtnLabel = 'Zmień ustawienia';
      this.actionQuestion = 'Na pewno chcesz zmienić ustawienia?';
      this.actionSuccess = 'Nowe ustawienia zostały zapisane';
      this.actionError = 'Wystąpił błąd podczas zapisywania ustawień'
      this.formGroup = this.formBuilder
        .group({
          photoImageUUID: [this.clientUserCarePlanSettings?.photoImageUUID],
          largePhotoImageUUID: [this.clientUserCarePlanSettings?.largePhotoImageUUID],
          name: [this.clientUserCarePlanSettings?.name, Validators.required],
          description: [this.clientUserCarePlanSettings?.description, Validators.required]
        });
    }
  }

  onAction() {
    if (this.formGroup.valid) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        let cps: ClientUserCarePlanSettings = this.commonUtils.formGroupValuesToObject<ClientUserCarePlanSettings>(new ClientUserCarePlanSettings(), this.formGroup);

        let serviceMethod;

        this.clientUserCarePlanSettings.photoImageUUID = cps.photoImageUUID;
        this.clientUserCarePlanSettings.largePhotoImageUUID = cps.largePhotoImageUUID;
        this.clientUserCarePlanSettings.name = cps.name;
        this.clientUserCarePlanSettings.description = cps.description;

        serviceMethod = this.clientsService.updateClientUserCarePlanSettings(this.clientUserCarePlanSettings);


        this.handleActionMethod(serviceMethod, this.clientUserCarePlanSettingsAddedEmitter, this.clientUserCarePlanSettingsAddedEmitter);

      }, () => {
      });
    } else {
      this.commonUtils.presentAlertToast('Popraw błędy w formularzu');
    }
  }

  onCancelEdit() {
    if (this.hasUnsavedChanges || this.images?.length > 0) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z zapisu?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.clientUserCarePlanSettingsEditCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.clientUserCarePlanSettingsEditCanceledEmitter.emit(true);
    }
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.hasUnsavedChangesEmitter.emit(true);
    }
  }

  async openImageDropForPhoto(formControlName: 'photoImageUUID' | 'largePhotoImageUUID') {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vClientUUID': this.vClientUUID,
        'imageFolder': 'care-plan'
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== undefined && dismissData.data != null) {
        if (formControlName === 'photoImageUUID') {
          this.clientUserCarePlanSettings.photo = dismissData.data;
          this.clientUserCarePlanSettings.photoImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'largePhotoImageUUID') {
          this.clientUserCarePlanSettings.largePhoto = dismissData.data;
          this.clientUserCarePlanSettings.largePhotoImageUUID = dismissData.data.uuid;
        }

        if (this.images) {
          this.images.push(dismissData.data)
        } else {
          this.images = [];
          this.images.push(dismissData.data)
        }

        this.formGroup.get(formControlName).setValue(dismissData.data?.uuid);
        this.markUnsavedChanges();
      }
    });

    return await modal.present();
  }

  getImageSrcById(imgUUID: string, width) {
    if (this.vImages) {
      return this.commonUtils.getVImageUrlPath(this.vClientUUID, width, this.vImages.find(({uuid}) => uuid === imgUUID));
    }
  }


  revertImage(valueToRevert: string, image: VImage) {
    if (valueToRevert === 'largePhoto') {
      this.clientUserCarePlanSettings.largePhoto = this.largePhoto;
      this.clientUserCarePlanSettings.largePhotoImageUUID = this.largePhotoImageUUID;
    }
    if (valueToRevert === 'photo') {
      this.clientUserCarePlanSettings.photo = this.photo;
      this.clientUserCarePlanSettings.photoImageUUID = this.photoImageUUID;

    }
    if (this.images) {
      this.images = this.images.filter(e => e.uuid !== image.uuid);
    }
  }

  ngOnDestroy() {
    if (this.vImagesSub) {
      this.vImagesSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

}

